import React from 'react'
import NavBar from '../components/NavBar/navBar.component'
import AboutHero from '../components/About/aboutHero.component'
import Benifits from "../components/About/benifits.component"
import Footer from '../components/Footer/footer.component'

function About() {
  return (
    <>
        <NavBar/>
        <AboutHero/>
        <Benifits/>
        <Footer/>
    </>
  )
}

export default About